export default __webpack_public_path__ + "static/OYOY-1280x260-60fps-16a5832f326e342ee39c92b07857326d.mp4";